<template>
    <div
        class="zedplan-player player"
        data-vjs-player
    >
        <video class="video-js vjs-default-skin vjs-big-play-centered"
               width="100%"
               ref="player"
        >
        
        </video>
    </div>
</template>
<script>
import videojs from "video.js";
import chromecast from "@silvermine/videojs-chromecast";
import "video.js/dist/video-js.css";
import "@silvermine/videojs-chromecast/dist/silvermine-videojs-chromecast.css";
import './../../../modules/videojs-quality-selector/plugin.css';
require('./../../../modules/videojs-quality-selector/plugin');

export default {
    props: {
        data: {
            type: Object,
            required: true,
            validator(data){
                return true;
                return typeof data.url === String && data.url.length > 0;
            }
        },
        poster: {
            type: String,
            required: false
        },
        title: {
            type: String,
            required: true,
        },
        subtitle: {
            type: String,
            required: true
        }
    },
    computed: {
        source(){
            return this.data.playlist_url;
        }
    },
    data(){
        return {
            player: null
        }
    },
    methods: {
        initPlayer(){
            chromecast(videojs);
            
            this.player = videojs(this.$refs.player, {
                autoplay: false,
                controls: true,
                languages: {
                    es: require('../../../lang/videojs/es.json'),
                    en: require('../../../lang/videojs/en.json'),
                    //de: require('../../../lang/videojs/de.json')
                },
                language: this.$i18n.locale,
                techOrder: ["chromecast", "html5"],
                poster: this.poster,
                controlBar: {
                    children: [
                        'playToggle',
                        'progressControl',
                        'volumePanel',
                        'fullscreenToggle',
                        //'Chromecast'
                    ],
                },
                notSupportedMessage: this.$t('player.not_supported'),
                html5: {
                    hls: {
                        overrideNative: true
                    }
                },
                plugins: {
                    chromecast: {}
                },
                chromecast:{
                    requestTitleFn: source => {return this.title},
                    requestSubtitleFn: (source) => {return this.subtitle},
                    
                },
                sources: [
                    {
                        src: this.source,
                        type: "application/x-mpegURL"
                    }
                ]
            });
            
            this.player.QualitySelector({
                maximumDefaultQuality: {
                    bitrate: 1536000
                }
            });
        }
    },
    mounted(){
        this.$refs.player.addEventListener('ended',() => {
            this.$emit('videoEnded');
        },false);
        
        this.$refs.player.addEventListener('play',() => {
            this.$emit('videoStarted');
        },false);
        
        this.initPlayer();
    },
    beforeDestroy() {
        if (this.player) {
            this.player.dispose();
        }
        this.player = null;
    }
}
</script>

<style scoped lang="scss">
.player{
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    width: 100%;
}

.video-js{
    width: 100%;
    //min-height: 500px;
    background-color: #000000;
    height: 100%;
    
    @media(max-width: 900px){
        min-height: 300px;
        height: auto;
    }
    
    @media(max-width: 480px){
        min-height: 100px;
        height: auto;
    }
    
    
    .vjs-tech {
        height: unset;
        position: relative;
        max-height: 95vh;
        
    }
    
}
</style>